module.exports = __webpack_public_path__ + "img/recommed-img1.94be6f09.jpg";